// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"title___EAYj9"};